module.exports = __webpack_public_path__ + "static/media/jinggaotishi.498bba80.png";